import { ErrorCross } from 'components/ErrorCross';
import { InvoicesContext } from 'context/invoices.context';
import { InvoicePaymentDetails } from 'pages/Invoices/components/InvoicePaymentDetails';
import React, { useContext, useEffect, useState } from 'react';
import { ContentUtil } from 'utils/content';

import { InvoiceSummary } from '../../../../../../api/invoice.types';
import { content } from './payment-failed.content';
import { Content, Title, TopContent } from './payment-failed.styles';

const contentUtil = new ContentUtil({ content, componentName: 'PaymentFailed' });

interface PaymentFailedProps {
  invoiceId: string;
}

export const PaymentFailed = ({ invoiceId }: PaymentFailedProps) => {
  const [invoice, setInvoice] = useState<InvoiceSummary | null>(null);
  const [hasError, setHasError] = useState(false);

  const { getInvoiceById } = useContext(InvoicesContext);

  useEffect(() => {
    getInvoiceById(invoiceId)
      .then((response) => setInvoice(response))
      .catch(() => setHasError(true));
  }, [invoiceId]);

  return (
    <>
      <TopContent data-testid="payment-failed">
        <Title>
          <h1>{contentUtil.translate('title')}</h1>
        </Title>
        <Content>{contentUtil.translateHtml('content')}</Content>
        {hasError && <ErrorCross>{contentUtil.translate('error')}</ErrorCross>}
      </TopContent>
      {invoice && <InvoicePaymentDetails invoice={invoice} />}
    </>
  );
};
